import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SaleOrderModel, DocumentCode, ActiveDocumentVersionVm } from 'shared/models';
import { LoadingService } from 'shared/core';
import { AuthService } from 'shared/core';
import { CompanyInfo } from 'shared/models';
import { AlertMessageService } from 'shared/core';
import { DocumentService } from 'shared/core';

@Component({
    selector: 'app-InspectionDetailsMixingPrint',
    templateUrl: './InspectionDetailsMixingPrint.component.html',
    styleUrls: ['./InspectionDetailsMixingPrint.component.css'],
    standalone: false
})
export class InspectionDetailsMixingPrintComponent implements OnInit {
    ApiUrl = environment.Api_Url;
    ProductionList: SaleOrderModel[] = [];
    ProductionListOriginal: SaleOrderModel[] = [];
    Production!: SaleOrderModel;
    isVisible = false;
    isLoading: boolean = false;
    isTableLoading: boolean = false;
    typeList: any[] = [];
    PopUpTitle: string = "Add New Production";
    searchValue = '';
    visible = false;
    private route$: Subscription = new Subscription;
    SaleOrderId = 0;
    MixingName = '';
    PrintStr = ''
    EmbossingStr = ''
    TumblingStr = ''
    LacquerStr = ''
    VaccumStr = ''
    permission = {
        View: false,
        SaleOrderView: false
    }
    Company = {
        CompanyName: '',
        HeadOfficeAddress: '',
        FactoryAddress: ''
    };
    totalCalculatedQuantities: { [mixingName: string]: number } = {};
    totalCalculatedSCQuantities: { [mixingName: string]: number } = {};
    totalAllQuantities: { [mixingName: string]: number } = {};
    totalAllSCQuantities: { [mixingName: string]: number } = {};
    TotalProductionQty: number = 0;
    FabricQTYFromKGToMTR: number;
    ActiveDocumentVersion: ActiveDocumentVersionVm;

    constructor(public http: HttpClient, private route: ActivatedRoute, private loader: LoadingService, private auth: AuthService,
        private router: Router, private alertService: AlertMessageService, private documentService: DocumentService) { }

    ngOnInit() {
        this.route$ = this.route.params.subscribe((params: Params) => {
            this.SaleOrderId = params["id"];
            this.MixingName = params["mixingName"];
        })
        this.Company.CompanyName = CompanyInfo.CompanyName;
        this.Company.HeadOfficeAddress = CompanyInfo.HeadOfficAddress;
        this.Company.FactoryAddress = CompanyInfo.FactoryAddress;

        this.GetProductionDatabyid(this.SaleOrderId);
        this.GetDocumentVersion();
    }

    GetDocumentVersion() {
        this.documentService.getActiveVersionByCode(DocumentCode.InspectionMixing)
            .subscribe(res => {
                this.ActiveDocumentVersion = res;
            });
    }

    GetProductionDatabyid(id: number) {
        this.loader.show();
        let url = this.ApiUrl + "saleorder/getsaleorderdatabyid/" + id;
        this.http.get<any>(url).subscribe(res => {

            this.Production = res;

            // Filter for specific mixing if MixingName is provided
            if (this.MixingName) {
                this.Production.SaleOrderProduction.InspectionFormulationMixing =
                    this.Production.SaleOrderProduction.InspectionFormulationMixing.filter(
                        x => x.MixingName.toLowerCase() === this.MixingName.toLowerCase()
                    );
            }

            if (this.Production.Status.toString() != "WorkPlan") {
                //this.IsInspectionCompleted = true
            }
            this.calclulateTotalSalePrice()
            this.Production.SaleOrderProduction.RawGSMTotal = 0;
            this.Production.SaleOrderProduction.SaleOrderProductionRawMaterial.forEach((element) => {

                this.Production.SaleOrderProduction.RawGSMTotal += parseFloat(element.Quantity.toString()) * (isNaN(parseInt(element.AvgGsm?.toString())) ? 0 : parseInt(element.AvgGsm?.toString()))
            });
            this.Production.SaleOrderProduction.MixingGSMTotal = this.Production.SaleOrderProduction.MixingTotalCost = 0;
            // Note: We might want to calculate totals based on ALL mixings or just the filtered one?
            // Usually totals in the header should probably reflect the whole order, but the body shows specific mixing.
            // Keeping original logic for totals for now as it iterates over FormulationMixing which might be different from InspectionFormulationMixing
            // However, looking at original code:
            this.Production.SaleOrderProduction.FormulationMixing.forEach(element => {
                this.Production.SaleOrderProduction.MixingTotalCost += isNaN(element.Total) ? 0 : element.Total;
                this.Production.SaleOrderProduction.MixingGSMTotal += isNaN(parseInt(element.WeightGsm?.toString())) ? 0 : parseInt(element.WeightGsm.toString());
            })

            this.calculateFormulaQuantityAfterInspection();

            this.Production.SaleOrderProduction.FinalMixingGSMTotal = this.Production.SaleOrderProduction.MixingGSMTotal + this.Production.SaleOrderProduction.RawGSMTotal;
            var totalprint = this.Production.SaleOrderProduction?.SaleOrderProductionPrint.reduce((sum, current) => sum + parseFloat(current.Total?.toString()), 0) ?? 0
            var totalEmbossing = this.Production.SaleOrderProduction?.SaleOrderProductionEmbossing.reduce((sum, current) => sum + parseFloat(current.Total?.toString()), 0) ?? 0
            var totalVaccum = this.Production.SaleOrderProduction?.SaleOrderProductionVacuum.reduce((sum, current) => sum + parseFloat(current.Total?.toString()), 0) ?? 0
            var totalTumbling = this.Production.SaleOrderProduction?.SaleOrderProductionTumbling.reduce((sum, current) => sum + parseFloat(current.Total?.toString()), 0) ?? 0
            var totalElement = this.Production.SaleOrderProduction?.SaleOrderProductionElement.reduce((sum, current) => sum + parseFloat(current.Total?.toString()), 0) ?? 0
            var totalRaw = this.Production.SaleOrderProduction?.SaleOrderProductionRawMaterial.reduce((sum, current) => sum + parseFloat(current.TotalCost?.toString()), 0) ?? 0

            this.Production.GrandTotal = parseFloat(this.Production.SaleOrderProduction?.TotalCost.toString()) + parseFloat(this.Production.SaleOrderProduction?.ColorPrice.toString()) +
                parseFloat(this.Production.SaleOrderProduction?.GrainPrice.toString()) +
                parseFloat(this.Production.SaleOrderProduction?.ThickPrice.toString()) +
                parseFloat(this.Production.SaleOrderProduction?.WidthPrice.toString()) +
                parseFloat(isNaN(totalprint) == true ? "0" : totalprint.toString()) +
                parseFloat(isNaN(totalEmbossing) == true ? "0" : totalEmbossing.toString()) +
                parseFloat(isNaN(totalVaccum) == true ? "0" : totalVaccum.toString()) +
                parseFloat(isNaN(totalTumbling) == true ? "0" : totalTumbling.toString()) +
                parseFloat(isNaN(totalElement) == true ? "0" : totalElement.toString()) +
                parseFloat(totalRaw.toString());
            this.SetTotalProductionQty()

            // This part accesses index 0 of InspectionFormulationMixing which might cause issues if filtered array is empty or doesn't have the expected items in order
            // Since we filtered InspectionFormulationMixing, we need to be careful. 
            // The original code was summing up specific properties from the first item? No, it looks like it was summing up properties from the 0th index? 
            // Wait, this looks like a bug in the original code or a specific requirement where they assume index 0 has all GSMs?
            // "this.Production.SaleOrderProduction.InspectionFormulationMixing[0].PreSkinGsmPasteReq"
            // For per-mixing print, we might only have one item in the array.

            // If we filter, we might lose the element that has these values if it's not the one selected.
            // However, these properties seem to be on the Mixing object.
            // Let's rely on the backend data or safe check.

            if (this.Production.SaleOrderProduction.InspectionFormulationMixing.length > 0) {
                // Use the first item of the filtered list, or we might need to look at the original list if these values are needed from a specific mixing type
                // But these look like "Req" (Requirement) values. available on any mixing object? No, specific to mixing type.
                // The original code does:
                // this.Production.SaleOrderProduction.InspectionFormulationMixing[0].PreSkinGsmPasteReq 
                // + ...AlignmentGsmPasteReq...

                // If the user selects "Adhesive", and we filter down to only "Adhesive" array, then index 0 is Adhesive.
                // Does Adhesive have PreSkinGsmPasteReq? Probably 0 or undefined.

                // Ideally we should calculate this Total GSM before filtering.
                // But since this is just display of "FinalMixingGSMTotal", and for a specific mixing print we might not even need this total line if it's not relevant?
                // But let's try to preserve it.
                // I will reference the original list (which I didn't save before filtering... wait)
                // I should filter AFTER calculating totals if I need totals from all.
            }

            setTimeout(function () {
                window.print();
                window.onafterprint = close;
                function close() {
                    window.close();
                }
            }, 1)
            this.loader.hide();
        });
    }

    SetTotalProductionQty() {
        if (this.Production.SaleOrderProduction.ExtraProduction > 0) {
            this.TotalProductionQty = parseFloat((this.Production.SaleOrderProduction.OrderQuantity + (this.Production.SaleOrderProduction.OrderQuantity * this.Production.SaleOrderProduction.ExtraProduction) / 100).toFixed(2));
            this.calculateFabricQtyKGtoMTR()
        }
        else {
            this.TotalProductionQty = this.Production.SaleOrderProduction.OrderQuantity;
            this.calculateFabricQtyKGtoMTR();
        }
    }
    calclulateTotalSalePrice() {
        this.Production.SaleOrderProduction.TotalSalePrice = parseFloat(((isNaN(this.Production.SaleOrderProduction.OrderQuantity) ? 0 : this.Production.SaleOrderProduction.OrderQuantity) * (isNaN(this.Production.SaleOrderProduction.SalePrice) ? 0 : this.Production.SaleOrderProduction.SalePrice)).toString()).toFixed(2)
    }
    calculateFormulaQuantityAfterInspection() {
        this.Production.SaleOrderProduction.InspectionFormulationMixing.forEach(element => {
            let totalCalculatedForMixing = 0;
            let totalCalculatedSCForMixing = 0;
            let totalAllForMixing = 0;
            let totalAllSCForMixing = 0;
            element.MixingRawMaterial.forEach(raw => {
                totalAllForMixing += raw.Quantity;
                totalAllSCForMixing += raw.Scquantity;
                if (!raw.IsPigment) {
                    totalCalculatedForMixing += raw.Quantity;
                    totalCalculatedSCForMixing += raw.Scquantity;
                }
            })
            this.totalCalculatedQuantities[element.MixingName.trim().toLowerCase()] = parseFloat(totalCalculatedForMixing.toFixed(2));
            this.totalCalculatedSCQuantities[element.MixingName.trim().toLowerCase()] = parseFloat(totalCalculatedSCForMixing.toFixed(2));
            this.totalAllQuantities[element.MixingName.trim().toLowerCase()] = parseFloat(totalAllForMixing.toFixed(2));
            this.totalAllSCQuantities[element.MixingName.trim().toLowerCase()] = parseFloat(totalAllSCForMixing.toFixed(2));
        })
    }
    hasPigment(materials: any[]): boolean {
        return materials.some(r => r.IsPigment);
    }
    calculateFabricQtyKGtoMTR() {
        if (this.Production.SaleOrderProduction.InspectionSaleFormulationCode?.FabricProductUnit != "Mtrs" && this.Production.SaleOrderProduction.FabricProductId > 0) {
            if (this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricWidthInMeter != null && this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricWidthInMeter > 0 && this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricGsm != null && this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricGsm > 0) {
                this.FabricQTYFromKGToMTR = parseFloat(((this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricProductQty * 1000) / (this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricGsm * this.Production.SaleOrderProduction.InspectionSaleFormulationCode.FabricWidthInMeter)).toFixed(2));
            } else {
                this.FabricQTYFromKGToMTR = this.TotalProductionQty;
            }
        }
    }
}
